export const actionColumnProps = (props) => ({
  width: 20,
  minWidth: 0,
  type: 'action',
  align: 'center',
  disableFilters: true,
  ...props,
});
